import React from "react";
import { OverviewTableBody } from "./OverviewTableBody";
import { TextCustom } from "../../../../ui/TextCustom";
import { IPassengerTable } from "../../../../../interface/interfaces";

export const OverviewJsonToTables = ({ data }: { data: IPassengerTable[] }) => {
    return (
      <div>
        {data.map((item, index) => (
          <div key={index}>
            {/* <SpacingCustom paddingBottom={1}>
                <h3>Passenger {index + 1}</h3>
            </SpacingCustom> */}
            <table border={1} style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ddd", borderRadius: "10px" }}>
              <thead >
                <tr style={{border: "1px solid #ddd"}}>
                    <th style={{ padding: "8px", textAlign: "left", backgroundColor: "#f2f2f2"}}>
                        <TextCustom color="dark" size={1.2} weight={700}>{item.Description}</TextCustom>
                    </th>
                    <th style={{ padding: "8px", textAlign: "left", width: "500px", backgroundColor: "#f2f2f2"}}></th>
                </tr>
              </thead>
              <tbody>{OverviewTableBody(item.Content)}</tbody>
            </table>
            <br />
          </div>
        ))}
      </div>
    );
  };